module.exports = __webpack_public_path__ + "static/media/confounded.aca8a4f4.png";